import { render, staticRenderFns } from "./PurchaseOrderRemarks.vue?vue&type=template&id=6d6f71fc"
import script from "./PurchaseOrderRemarks.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6f71fc')) {
      api.createRecord('6d6f71fc', component.options)
    } else {
      api.reload('6d6f71fc', component.options)
    }
    module.hot.accept("./PurchaseOrderRemarks.vue?vue&type=template&id=6d6f71fc", function () {
      api.rerender('6d6f71fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderRemarks.vue"
export default component.exports